import React from "react";
import PointerImg from "../../assets/images/Pointer.png";

const Pointer = React.memo(() => (
  <div className="fixed left-1/2 bottom-[3.5rem] transform -translate-x-1/2 z-30 flex flex-col items-center">
    <img
      src={PointerImg}
      alt="Pointer"
      className="w-20 h-20 object-contain drop-shadow-xl mb-2"
    />
    <span className="text-white text-[18px] font-bmw font-light" style={{ textShadow: '0 2px 0.8px rgba(0, 0, 0, 0.25), 1px 2px 4px rgba(0, 0, 0, 0.25), 0 4px 4px rgba(0, 0, 0, 0.25)' }}>Tap on the hotspot</span>
  </div>
));

export default Pointer;
